var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPaperClip = function SvgPaperClip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 508.258 508.258",
    height: 512,
    viewBox: "0 0 508.258 508.258",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m267.167 35.44-243.442 222.791 20.254 22.131 243.442-222.792c42.47-38.869 107.775-36.123 146.945 5.077l18.489-4.347 2.733-16.875c-50.621-52.676-134.204-55.602-188.421-5.985z",
    fill: "#76e2f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.949 361.007 260.04-237.981c12.533-11.47 32.526-10.448 43.644 3.355l19.611-5.469 1.661-15.803c-22.353-24.927-60.573-26.725-85.17-4.213l-260.04 237.98c-36.645 33.534-41.303 87.681-15.02 126.462l15.97-1.828 5.83-19.972c-14.617-26.253-10.396-60.688 13.474-82.531z",
    fill: "#76e2f8"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4bb9ec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m455.589 41.425-21.223 21.223c40.777 42.938 38.006 110.328-5.17 149.841l-271.106 248.108c-32.218 29.486-83.392 21.045-104.614-17.06l-21.8 21.8c33.592 49.577 103.036 57.32 146.668 17.391l271.106-248.108c55.688-50.963 58.859-138.326 6.139-193.195z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.497 167.288-232.377 212.664 20.254 22.131 232.377-212.663c24.278-22.218 26.156-59.786 4.154-84.311l-21.272 21.272c9.782 12.152 8.692 30.083-3.136 40.907z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaperClip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paper-clip.c35337ec.svg";
export { ForwardRef as ReactComponent };